var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTermChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18c-.55 0-1.021-.196-1.413-.587A1.928 1.928 0 010 16V2C0 1.45.196.979.587.587A1.928 1.928 0 012 0h14c.55 0 1.021.196 1.413.587C17.804.979 18 1.45 18 2v14c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0116 18H2zm5.6-5.225c.133 0 .258-.02.375-.062A.883.883 0 008.3 12.5l5.675-5.675a.918.918 0 00.275-.675c0-.267-.1-.5-.3-.7a.948.948 0 00-.7-.275.948.948 0 00-.7.275L7.6 10.4 5.425 8.225a.918.918 0 00-.675-.275c-.267 0-.5.1-.7.3a.948.948 0 00-.275.7c0 .283.092.517.275.7L6.9 12.5c.1.1.208.171.325.213.117.041.242.062.375.062z",
    fill: "#02B7B0"
  })));
}

export default SvgTermChecked;